module.exports = __webpack_public_path__ + "img/full0-min.fc088fd5.png";